export default "<p>customeropinion works!</p>\n";